import { pluginKey } from './plugin-key';
export var openHelpAction = function openHelpAction(tr) {
  return tr.setMeta(pluginKey, true);
};
export var closeHelpAction = function closeHelpAction(tr) {
  return tr.setMeta(pluginKey, false);
};